export default "__VITE_ASSET__DlC5lUxG__"